import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE K-SMART VISUAL SYSTEM™',
  ideal: 'Anyone who wants to understand Korean from zero, without studying languages before',
  was: '$129',
  symbol: '$',
  amount: '19',
  currency: 'USD',
  features: ['6 Complete Volumes (120+ pages)', 'Hangul from zero, explained visually', 'Real K-Drama & K-Pop expressions', '30-Day routine with visible progress', '5 Free Bonuses included', '7-Day Money-Back Guarantee'],
  cta: 'Get The K-Smart Visual System'
};

// Edit these three sizes freely — the amount stays optically centered either way.
const symbolSize = '38px';
const amountSize = '75px';
const currencySize = '26px';
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-153" data-mp="4v8l4o0swffy">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-154" data-mp="9q5w40hn4yvh">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-cream px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(192,57,43,0.42)]" data-id="element-155" data-mp="3d8z4zzzh4zjb">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-156" data-mp="2ui7mo8xidyss">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-157" data-mp="2zfzopvrvb1ap">
            <span className="font-semibold text-plum/80" data-id="element-158" data-mp="2rglb1tsdpv9m">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-159" data-mp="2mi1jndv0nr9v">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-160" data-mp="2mh09rcpqlatq">{plan.was}</span>

            <div className="flex justify-center" style={{
            paddingTop: "20px",
            paddingBottom: "26px"
          }} data-id="element-161" data-mp="318iprailj5d3">
              <span className="text-grape-shine relative font-display font-black leading-none" style={{
              fontSize: amountSize,
              fontFamily: "Cinzel, serif"
            }} data-id="element-162" data-mp="28i0mo9hvh3zo">
                <span className="absolute right-full top-1/2 -translate-y-1/2 pr-1 leading-none" style={{
                fontSize: "52px",
                color: "#C84736"
              }} data-id="element-163" data-mp="2ig6nenry042y">
                  {plan.symbol}
                </span>
                {plan.amount}
                <span className="absolute left-full top-1/2 -translate-y-1/2 pl-2 leading-none" style={{
                fontSize: currencySize,
                color: "#C84736"
              }} data-id="element-164" data-mp="3tuk5fc00lpb2">
                  {plan.currency}
                </span>
              </span>
            </div>

            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-165" data-mp="cgjjyudouzc">
              One-time payment · Lifetime access
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-166" data-mp="3nfczipwlep6d">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-167" data-mp="3riredd8sozi8">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-168" data-mp="j1n5rvuds4pw">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-169" data-mp="nzgbknrruwpn" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-170" data-mp="ea54t7scy44x">
            <CTAButton size="md" data-id="element-171" data-mp="e8llf8bencyx">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-172" data-mp="11yodvpj8eky2">
            You save $110 USD (85% OFF)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-173" data-mp="16s0ogvr2sr7t">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-174" data-mp="3a6ukyxr4g7i7">
                <Icon className="h-4 w-4 text-grape" data-id="element-175" data-mp="35adtpuomld0w" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-176" data-mp="319tzozzcmpiz" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-177" data-mp="1scidbjy9k5z">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-178" data-mp="3t085sa14exk3" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-179" data-mp="3o7f2zrp7pzan">
            <span className="font-display font-bold text-plum" data-id="element-180" data-mp="3k6leox7uyih8">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the ebook does not match what you need or does not
            give you the boost you were looking for, request your refund and we return 100% of your
            money. We want you to learn with peace of mind, risk-free.
          </p>
        </div>
      </div>
    </section>;
}